export default {
    ELETIVO: 1,
    URGENCIA: 2,
    PRIORITARIO: 3,
    EMERGENCIA: 4,
}